import React, { useState } from "react"
import { Field as AvField, Form as AvForm } from "@availity/form"
import { Button, Card, CardBody, Form, FormGroup, Input, Label } from "reactstrap"
import Dropzone from "react-dropzone"

const CreateNewTrading = () => {
    const [newList, setNewList] = useState({
        img: "",
        title: "New List",
        description: "",
        price: 0,
        ownership: "Auction"
    })
    const [imgFile, setImgFile] = useState([])

    const handleAcceptedFiles = async (files) => {
        const toBase64 = (file) =>
            new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () =>
                    resolve(
                        Object.assign(file, {
                            preview: URL.createObjectURL(file),
                            base64: reader.result.split(",")[1]
                        })
                    )
                reader.onerror = (error) => reject(error)
            })

        const base64Files = await Promise.all(
            files.map((file) => {
                return toBase64(file)
            })
        )

        setImgFile(base64Files)
        if (base64Files.length > 0 && base64Files[0].preview) {
            setNewList({ ...newList, img: base64Files[0].preview })
        }
    }

    const handleNewList = (key, value) => {
        setNewList({
            ...newList,
            [key]: value
        })
    }

    const handleSubmit = async (event) => {
        if (imgFile.length === 0 || imgFile[0].base64 === undefined) {
            alert("Please upload image for new list")
            return
        }
    }

    return (
        <React.Fragment>
            <div className="content trading-page">
                <Card>
                    <CardBody>
                        <div className="create-new-list">
                            <h1 className="mt-1 mb-3">Create a new listing</h1>
                            <div className="create-new-list__content">
                                <div className="add-list-form">
                                    <AvForm initialValues={{ title: "" }} onSubmit={handleSubmit}>
                                        <Form className="dropzone">
                                            <Dropzone onDrop={(dropFiles) => handleAcceptedFiles(dropFiles)} maxFiles={1}>
                                                {({ getRootProps, getInputProps }) => (
                                                    <div className="d-flex flex-column align-items-center h-100">
                                                        <div className="list-image-select needsclick" {...getRootProps()}>
                                                            <input {...getInputProps()} />
                                                            {imgFile.length > 0 ? (
                                                                <img className="selected-image" alt={imgFile[0].name} src={imgFile[0].preview} />
                                                            ) : (
                                                                <div className="list-image-select needsclick" style={{ padding: "40px 0" }}>
                                                                    <div className="mb-3">
                                                                        <i className="display-4 text-muted bx bxs-cloud-upload" />
                                                                    </div>
                                                                    <h4>Drop files here or click to upload.</h4>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </Dropzone>
                                        </Form>
                                        <FormGroup className="my-3">
                                            <AvField
                                                name="title"
                                                label="Title"
                                                className="form-control"
                                                placeholder="Enter Title"
                                                type="text"
                                                onChange={(e) => handleNewList("title", e.target.value)}
                                                required
                                            />
                                        </FormGroup>
                                        <FormGroup className="mb-3">
                                            <AvField
                                                name="description"
                                                label="Description"
                                                className="form-control"
                                                placeholder="Description"
                                                type="textarea"
                                                onChange={(e) => handleNewList("description", e.target.value)}
                                                rows="5"
                                                required
                                            />
                                        </FormGroup>
                                        <p className="ownership-label">Ownership</p>
                                        <div className="ownership">
                                            <FormGroup className="mb-1">
                                                <Input type="checkbox" id="my_wallet" />
                                                <Label htmlFor="my_wallet" className="label-for-checkbox">
                                                    Mint to my wallet
                                                </Label>
                                            </FormGroup>
                                            <FormGroup className="mb-1">
                                                <Input type="checkbox" id="sell" />
                                                <Label htmlFor="sell" className="label-for-checkbox">
                                                    Sell for a fixed price
                                                </Label>
                                            </FormGroup>
                                            <FormGroup className="mb-1">
                                                <Input type="checkbox" id="auction" />
                                                <Label htmlFor="auction" className="label-for-checkbox">
                                                    Auction
                                                </Label>
                                            </FormGroup>
                                        </div>
                                        <Button type="submit" color="primary" className="btn btn-primary btn-md mt-2">
                                            Create Listing
                                        </Button>
                                    </AvForm>
                                </div>
                                <div className="preview-card">
                                    <div className="card-item">
                                        <div className="img-container">
                                            {!!newList.img ? <img src={newList.img} alt="card-image" /> : <div className="blank-img" />}
                                        </div>
                                        <div className="card-content-body">
                                            <p className="card-title">{newList.title}</p>
                                        </div>
                                        <div className="card-content-footer">
                                            <span>${newList.price}</span>
                                            <span className="action-icon">
                                                <i className="bx bx-question-mark" />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </div>
        </React.Fragment>
    )
}

export default CreateNewTrading
